import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/sections/Hero';
import { AboutPreview } from '../components/sections/AboutPreview';
import { ServicesGrid } from '../components/sections/ServicesGrid';
import { Advantages } from '../components/sections/Advantages';
import { ReviewsSlider } from '../components/sections/ReviewsSlider';
import { ContactCTA } from '../components/sections/ContactCTA';

export const Home = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Hero />
        <AboutPreview />
        <ServicesGrid />
        <Advantages />
        <ReviewsSlider />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
};
